// 获取url 参数
export const getQuery = name => {
    // eslint-disable-next-line
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
// 将日期对象转成 xxxx-xx-xx
export const dataFormatter = date => {
    let year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
    month = month < 10 ? '0' + month : '' + month;
    day = day < 10 ? '0' + day : '' + day;
    return year + '-' + month + '-' + day;
}
//小数点后不足两位补齐，多于两位
export const returnFloat = value => {
    var v = Math.round(parseFloat(value) * 100) / 100;
    var xsd = v.toString().split(".");
    if (xsd.length == 1) {
        v = v.toString() + ".00";
        return v;
    }
    if (xsd.length > 1) {
        if (xsd[1].length < 2) {
            v = v.toString() + "0";
        }
        return v;
    }
}